import SliderBase from './base-slider';
class ProductSliderHandler extends SliderBase {
  
}

export default ( $scope ) => {
	elementorFrontend.elementsHandler.addHandler( ProductSliderHandler, { $element: $scope } );
};
